module.exports = __webpack_public_path__ + "static/media/exitButton.37a93ad4.svg";